/* eslint-disable react/jsx-no-bind, react/jsx-closing-tag-location */
import React, {useState} from "react";
import Helper from "../../shared/modules/Helper";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import PropTypes from "prop-types";
import QuantityField from "../../shared/components/QuantityField";
import ScarcityMessaging from "../../bundles/Cart/ScarcityMessaging";

const NonMemberCartItemCard = ({id, itemInfo, refreshCart, setNotificationText, storeKind}) => {
  const [
    loading,
    setLoading
  ] = useState(false);

  const {
    "inventory_count": inventoryCount,
    price,
    "product_descriptor": productDescriptor,
    quantity
  } = itemInfo;

  const {
    "details": {
      designer,
      "kind_name": kindName,
      name,
      "retail_price": retailPrice,
      "ring_size": ringSize,
      "thumbnail_urls": thumbnailImages,
      url
    }
  } = productDescriptor;

  const handleDecreaseQuantity = () => {
    setLoading(true);
    NonMemberCartAPI.removeFromCart(itemInfo.product_descriptor.id, 1, storeKind).then(() => {
      refreshCart();
      setLoading(false);
    });
  };

  const handleIncreaseQuantity = () => {
    setLoading(true);
    NonMemberCartAPI.addToCart(itemInfo.product_descriptor.id, 1, storeKind).then((response) => {
      if (response.error) {
        setNotificationText(response.error);
      } else {
        refreshCart();
      }
      setLoading(false);
    });
  };

  const renderRetailPrice = () => {
    if (storeKind === "retail") return null;

    return `$${Helper.formatPriceCents(retailPrice)}`;
  };

  return (
    <div className="item-card">
      <div
        className="item-card-body cart-block"
        id={`${id}-${storeKind}`}
      >
        {storeKind === "clearance" &&
          <div className="clearance">
            <span className="clearance-stamp">
              CLEARANCE
            </span>
            <span className="final-sale-text">
              * Final Sale.
            </span>
          </div>
        }
        <div className="price-section">
          <div className="item-retail-price">
            {renderRetailPrice()}
          </div>
          <div className="item-discounted-price">
            {`$${Helper.formatPriceCents(price)}`}
          </div>
        </div>
        <div className="item-product">
          <a
            className="item-image-wrapper"
            href={url}
          >
            <img
              alt={`${designer} ${name}`}
              className="item-image"
              key={`${designer}-${name}-${quantity}`}
              src={thumbnailImages[0]}
            />
          </a>
          <div className="item-description">
            <a href={url}>
              <div className="item-designer">
                {designer}
              </div>
              <div className="item-name">
                {name}
              </div>
              {kindName === "Ring" && ringSize && <div className="item-size">
                Size:
                {" "}
                {ringSize}
              </div>}
            </a>
            <div className="item-scarcity-messaging">
              <ScarcityMessaging
                productDescriptorCount={inventoryCount}
              />
            </div>
          </div>
        </div>
        <div className="item-quantity">
          <QuantityField
            handleDecreaseQuantity={handleDecreaseQuantity}
            handleIncreaseQuantity={handleIncreaseQuantity}
            loading={loading}
            quantity={quantity}
          />
        </div>
      </div>
    </div>
  );
};

NonMemberCartItemCard.propTypes = {
  "id": PropTypes.string.isRequired,
  "itemInfo": PropTypes.object.isRequired,
  "refreshCart": PropTypes.func.isRequired,
  "setNotificationText": PropTypes.func.isRequired,
  "storeKind": PropTypes.string.isRequired
};

export default NonMemberCartItemCard;
